export const UPDATE_VENUE_STATUSES_WITH_FIREBASE= 'UPDATE_VENUE_STATUSES_WITH_FIREBASE'
export const UPDATE_VENUE_STATUSES_WITH_FIREBASE_SUCCESS= 'UPDATE_VENUE_STATUSES_WITH_FIREBASE_SUCCESS'
export const UPDATE_VENUE_STATUSES_WITH_FIREBASE_ERROR='UPDATE_VENUE_STATUSES_WITH_FIREBASE_ERROR'

export const UpdateVenueStatusesWithFirebase= (data) => ({
    type: UPDATE_VENUE_STATUSES_WITH_FIREBASE,
    payload: data
})